import { useRef, useEffect, useState } from 'react';

export const CTASection = () => {
  const sectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      
      const rect = sectionRef.current.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      
      const visibleTop = Math.max(0, viewportHeight - rect.top);
      const progress = Math.min(1, Math.max(0, visibleTop / viewportHeight));
      
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const headingWords = ["Ready", "to", "elevate", "your", "kitchen?"];

  return (
    <section
      ref={sectionRef}
      data-testid="cta-section"
      className="relative py-32 md:py-48 bg-tex-bg overflow-hidden"
    >
      {/* Ambient Glow */}
      <div 
        className="absolute inset-0"
        style={{
          background: `radial-gradient(ellipse at center, rgba(45, 26, 92, ${0.3 + scrollProgress * 0.2}) 0%, transparent 60%)`
        }}
      />
      
      {/* Dot Matrix */}
      <div className="absolute inset-0 dot-matrix opacity-10" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Left-aligned editorial heading */}
        <p
          className="font-raleway text-[10px] font-semibold uppercase tracking-[0.5em] text-tex-violet-bright mb-6"
          style={{
            opacity: Math.min(1, scrollProgress * 3),
            transform: `translateY(${Math.max(0, 20 - scrollProgress * 60)}px)`
          }}
        >
          Begin Your Journey
        </p>

        <h2
          data-testid="cta-heading"
          className="text-editorial-section text-white text-left mb-8"
        >
          {headingWords.map((word, i) => (
            <span
              key={i}
              style={{
                opacity: Math.min(1, Math.max(0, (scrollProgress - i * 0.05) * 4)),
                transform: `translateY(${Math.max(0, 30 - (scrollProgress - i * 0.05) * 120)}px)`,
                display: 'inline-block',
                marginRight: '0.3em'
              }}
            >
              {word}
            </span>
          ))}
        </h2>

        <p
          className="font-raleway text-base font-light text-tex-muted max-w-xl leading-relaxed mb-12"
          style={{
            opacity: Math.min(1, Math.max(0, (scrollProgress - 0.3) * 3)),
            transform: `translateY(${Math.max(0, 20 - (scrollProgress - 0.3) * 80)}px)`
          }}
        >
          Discover our collection of thoughtfully designed kitchenware,
          built for those who take cooking seriously.
        </p>

        <div
          className="flex flex-col sm:flex-row items-start gap-4"
          style={{
            opacity: Math.min(1, Math.max(0, (scrollProgress - 0.4) * 3)),
            transform: `translateY(${Math.max(0, 20 - (scrollProgress - 0.4) * 80)}px)`
          }}
        >
          <a
            href="https://shop.texstyleco.com"
            data-testid="cta-primary-btn"
            className="btn-primary"
          >
            Explore the Collection
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
